export const TEAM_ICON_KEYS = [
  "building-2",
  "landmark",
  "map-pin",
  "briefcase",
  "users",
  "home",
  "factory",
  "store",
  "star",
] as const;

export type TeamIconKey = (typeof TEAM_ICON_KEYS)[number];

export const TEAM_IDENTITY_COLOR_PALETTE = [
  "#173F35",
  "#1D4ED8",
  "#7C3AED",
  "#B45309",
  "#0F766E",
  "#BE123C",
  "#4338CA",
  "#166534",
] as const;

const LETTER_MARK_PREFIX = "letter:";
const LETTER_MARK_PATTERN = /^letter:[A-Z0-9]{1,2}$/;

export function isTeamIconKey(value: string): value is TeamIconKey {
  return TEAM_ICON_KEYS.includes(value as TeamIconKey);
}

export function normalizeTeamIdentityMark(
  value: string | null | undefined,
): string | null {
  const normalized = value?.trim().toLowerCase();
  if (!normalized) return null;
  if (isTeamIconKey(normalized)) return normalized;

  if (normalized.startsWith(LETTER_MARK_PREFIX)) {
    const letters = normalized
      .slice(LETTER_MARK_PREFIX.length)
      .replace(/\s+/g, "")
      .toUpperCase();
    const mark = `${LETTER_MARK_PREFIX}${letters}`;
    return LETTER_MARK_PATTERN.test(mark) ? mark : null;
  }

  return null;
}

export function getDefaultTeamIdentityMark(name: string): TeamIconKey {
  return TEAM_ICON_KEYS[hashString(name) % TEAM_ICON_KEYS.length]!;
}

export function getDefaultTeamBrandColor(name: string): string {
  return TEAM_IDENTITY_COLOR_PALETTE[
    hashString(`${name}:color`) % TEAM_IDENTITY_COLOR_PALETTE.length
  ]!;
}

export function getTeamIdentityLetter(
  name: string,
  mark: string | null | undefined,
): string {
  const normalized = normalizeTeamIdentityMark(mark);
  if (normalized?.startsWith(LETTER_MARK_PREFIX)) {
    return normalized.slice(LETTER_MARK_PREFIX.length);
  }
  return name.trim().charAt(0).toUpperCase() || "?";
}

function hashString(value: string): number {
  let hash = 0;
  for (const character of value) {
    hash = (hash << 5) - hash + character.charCodeAt(0);
    hash |= 0;
  }
  return Math.abs(hash);
}
